<div *ngIf="!draggable"  style="z-index: 999999;">
    <div class="modal-header">
        <h6 class="modal-title modal-title-success" id="modal-basic-title">{{message}}...</h6>
        <!-- <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        </button> -->
    </div>
        
    <div class="modal-body py-0 font-size-14 categorical-modal-body">
        <div class="card-form-content card-form-success">
            <div class="progress-record d-inline-block w-75 ">
                 <p><ngb-progressbar class="green-bg" type="success" [value]="percentage" style="background-color: #ffffff !important;"></ngb-progressbar></p>
            </div>
            <div  class="progress-text d-inline-block w-25 ps-3">{{percentage}}%</div>
        
            <div class="progress-error">  
                <p>{{message2}}</p>  
            </div>
        </div>  
    </div>
</div>
<div *ngIf="draggable" class="draggable-container" cdkDrag cdkDragBoundary=".modal" cdkDragRootElement="draggable-container">
    <div class="draggable-modal-content cursor-pointer" cdkDragHandle>
        <div  style="z-index: 999999;">
            <div class="modal-header">
                <h6 class="modal-title modal-title-success" id="modal-basic-title">{{message}}...</h6>
                <!-- <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                </button> -->
            </div>
                
            <div class="modal-body py-0 font-size-14 categorical-modal-body">
                <div class="card-form-content card-form-success">
                    <p *ngIf="config?.subtitle" class="mb-2 mt-1">{{config.subtitle}}</p>
                    <div class="progress-record d-inline-block w-75 ">
                         <p><ngb-progressbar class="green-bg" type="success" [value]="percentage" style="background-color: #ffffff !important;"></ngb-progressbar></p>
                    </div>
                    <div  class="progress-text d-inline-block w-25 ps-3">{{percentage}}%</div>
                
                    <div class="progress-error ps-0">  
                        <p>
                            {{message2|translate}}
                            <span class="dots" *ngIf="enableDynamicMessages">
                                <span>.</span><span>.</span><span>.</span>
                            </span>
                        </p>
                        <p class="mt-2">{{message3}}</p>  
                    </div>
                    <ng-container *ngIf="config?.actionButton?.noteMessage && config?.actionButton?.show">
                        <hr class="loading-modal-divider my-2 mt-5" />
                        <div *ngIf="config?.actionButton?.noteMessage" class="loading-modal-note d-flex">
                            <span class="loading-modal-note__icon me-2 material-symbols-outlined" aria-hidden="true">
                                info
                            </span>
                            <span class="loading-modal-note__text">
                                {{ config.actionButton.noteMessage }}
                            </span>
                        </div>
                        <ng-container *ngIf="config?.actionButton?.show">
                            <hr class="loading-modal-divider my-2" />
                            <div class="d-flex flex-wrap loading-modal-actions mt-3">
                                <button *ngIf="config?.actionButton?.primary" type="button"
                                    class="btn loading-modal-actions__btn loading-modal-actions__btn--primary flex-fill me-2 mb-2"
                                    [disabled]="config.actionButton.primary.disabled"
                                    (click)="config.actionButton.primary.action?.()">
                                    <span *ngIf="config.actionButton.primary.icon"
                                        class="material-symbols-outlined loading-modal-actions__icon"
                                        aria-hidden="true">
                                        {{ config.actionButton.primary.icon }}
                                    </span>
                                    <span class="loading-modal-actions__label">
                                        {{ config.actionButton.primary.label }}
                                    </span>
                                </button>
                                <button *ngIf="config?.actionButton?.secondary" type="button"
                                    class="btn loading-modal-actions__btn loading-modal-actions__btn--secondary flex-fill mb-2"
                                    [class.loading-modal-actions__btn--disabled]="config.actionButton.secondary.disabled"
                                    [disabled]="config.actionButton.secondary.disabled"
                                    (click)="config.actionButton.secondary.action?.()">
                                    <span class="loading-modal-actions__label">
                                        {{ config.actionButton.secondary.label }}
                                    </span>
                                    <span *ngIf="config.actionButton.secondary.icon"
                                        class="material-symbols-outlined loading-modal-actions__icon"
                                        aria-hidden="true">
                                        {{ config.actionButton.secondary.icon }}
                                    </span>
                                </button>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>  
            </div>
        </div>
    </div>
</div>